import { Params } from '@angular/router';
import { ApiQuery, COMPLETABLE_TASK_FACET, ExtractOnlyCompletableValue, SortInfo } from '@stylehaven/components';
import { LuceneHelper } from '../../helpers';
import { defaultPaginationInfo, PaginationInfo } from '../../record/entities/pagination/pagination-info.entity';
import { TaskSearch } from '../entities';
import { taskDueDateAscSortInfo } from '../entities/task-sort-info.entity';

export const MapToTaskSearch = (
    params: Params | null,
    urlQuery: ApiQuery | null,
    externalQuery: ApiQuery | null,
    sortInfo: SortInfo | null | undefined, // for whatever reason, sort info can be null or undefined in different task lists. Just leaving it as is for now.
    luceneHelper: LuceneHelper,
    userPagination: PaginationInfo = defaultPaginationInfo,
    /**
     * The per-column filters (`cf`) the table's headers hold. A slot of its own, because `externalQuery`
     * already carries the page's own scope and one would silently replace the other.
     */
    columnFilterQuery: ApiQuery | null = null
): TaskSearch => {
    const { page, size } = params || {};
    const queries: ApiQuery[] = [];
    const completable = ExtractOnlyCompletableValue(urlQuery, false) || params?.f?.includes('+completable=true');
    if (urlQuery) {
        const copy = urlQuery.copy();
        copy.deleteFieldIfPresent(COMPLETABLE_TASK_FACET);
        queries.push(copy);
    }
    if (externalQuery) {
        queries.push(externalQuery);
    }
    if (columnFilterQuery) {
        queries.push(columnFilterQuery);
    }
    const defaultSort = taskDueDateAscSortInfo;
    const sortField = sortInfo ? sortInfo.field : defaultSort.field;
    const sortDirection = sortInfo ? sortInfo.direction : defaultSort.direction;
    const actualPage = page || userPagination.page || defaultPaginationInfo.page;
    const actualSize = size || userPagination.resultsPerPage || defaultPaginationInfo.resultsPerPage;
    return {
        Q: queries && queries.length > 0 ? luceneHelper.queryToLuceneQuery(...queries) : undefined,
        Completable: completable,
        Sort: `${sortField},${sortDirection}`,
        // Ugly, but this object contains both the old and new style of pagination parameters
        Page: actualPage,
        Size: actualSize,
        StartIndex: determineStartIndex(actualPage, actualSize),
        NrOfResults: actualSize
    };
};

function determineStartIndex(page: number, size: number): number {
    if (page && size) {
        return Number(page) * Number(size);
    } else if (page) {
        return Number(page) * defaultPaginationInfo.resultsPerPage!!;
    }

    return 0;
}
